<template>
  <div class="page-content">
    <div class="page-title">Membership Types</div>
    <div class="text">
      <!-- （会员类型介绍）World Federation of UNESCO Clubs, Centres and Associations
      (WFUCA) is a non-governmental organization in official partnership
      (associate status) with UNESCO having its office at Bonvin Building in
      Paris. -->
      <p>
        The World Federation shall be composed of following categories of membership: <br />
      </p>
      <div style="display: flex">
        <span>1.</span
        ><span style="margin-left: 21px; margin-bottom: 20px;">
          <b>FULL MEMBERS：</b>National Coordination Structures or Federations of Clubs and
          Associations for UNESCO, covering at least three regularlyestablished Clubs and
          Associations for UNESCO for at least one year under the supervision of the National
          Commission for UNESCO of that country. No more than one full member may be admitted per
          country. They shall be entitled to vote and to stand for election at the World Congress
          subject to payment of the dues set out in this Constitution;</span
        >
      </div>
      <div style="display: flex">
        <span>2.</span
        ><span style="margin-left: 18px; margin-bottom: 20px;">
          <b>ASSOCIATE MEMBERS：</b>Structures of Clubs or Associations for UNESCO recommended by a
          country's National Commission for UNESCO where they have yet to be federated at national
          level or to attain the number stipulated in subparagraph 1 of this article. They shall act
          in an advisory capacity until progress has been made towards the setting up of a National
          Federation. They may attend the World Congress as an observer without having any voting
          right;</span
        >
      </div>
      <div style="display: flex">
        <span>3.</span
        ><span style="margin-left: 18px; margin-bottom: 20px;">
          <b>HONORARY MEMBERS AND BENEFACTORS：</b>
          Structures or individuals that have rendered or are likely to render services to the
          UNESCO Clubs Movement or that simply represent values close to the ideals championed by
          UNESCO Clubs Movement.</span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
    p {
      line-height: fh(31vh, pc);
      margin-bottom: 6px;
    }
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
